<template>
  <router-link :to="route" class="subscriber-row">
    <div class="cell center">
      <div class="badge" :class="statusClassList">{{ statusText }}</div>
    </div>
    <div class="cell">
      <h5>{{ user.name }}</h5>
      <p>{{ user.phoneNumber }}</p>
      <p class="font-red">{{ user.offlinePurchase }}</p>
    </div>
    <div class="cell">
      <h5>บ้านเลขที่ {{ home.addressNumber }}</h5>
      <p>โครงการ {{ home.project }}</p>
    </div>
    <div class="cell">
      <h5>{{ package.name }}</h5>
      <p>
        <span class="original-price" v-if="package.originalPrice">{{ originalPriceText }}</span>
        {{ billingCycle }}
      </p>
    </div>
    <div class="cell">
      <p v-if="totalCoinAmount">{{ totalCoinAmount }}</p>
      <p v-if="couponCode">{{ couponCode }}<br />{{ discountAmount }}</p>
      <h5>{{ paymentAmount }}</h5>
    </div>
    <div class="cell">
      <div class="badge" :class="categoryClassList">{{ categoryText }}</div>
      <h5>{{ purchasedAtText }}</h5>
    </div>
    <div class="cell center">
      <h5>{{ quantity }}</h5>
    </div>
    <div class="cell">
      <h5>{{ currentAppointment }}</h5>
      <p>{{ appointmentDurationTime }}</p>
    </div>
  </router-link>
</template>

<script>
import { toLocaleTH } from "@/lib/dateTime";
import { formatCurrencyAndTwoDecimalsString } from "@/lib/formatter";
import { subscriptionStatus } from "@/lib/mapper";

export default {
  props: [
    "user",
    "home",
    "package",
    "purchasedAt",
    "renewAt",
    "route",
    "status",
    "appointmentDate",
    "category",
    "quantity",
    "price",
    "appointmentDurationTime"
  ],
  computed: {
    originalPriceText() {
      if (!this.package.originalPrice) {
        return;
      }

      const price = formatCurrencyAndTwoDecimalsString((this.package.originalPrice / 100) * this.quantity);

      return `${price} บาท`;
    },
    totalPrice() {
      return this.price ? this.price : this.package.price;
    },
    billingCycle() {
      const totalPriceBeforeDiscount = formatCurrencyAndTwoDecimalsString(
        (this.totalPrice / 100) * this.quantity
      );
      const billingCycle =
        this.package.billingCycle > 1
          ? " " + this.package.billingCycle.toLocaleString() + " "
          : " ";

      return `${totalPriceBeforeDiscount} บาท /${billingCycle}${this.cycleUnit}`;
    },
    cycleUnit() {
      return this.package.billingCycle === 0 ? "ครั้ง" : "เดือน";
    },
    paymentAmount() {
      if (this.categoryText == 'free_trial') {return 'Free'};

      const amount = this.package.paymentAmount;

      const paymentAmount = formatCurrencyAndTwoDecimalsString(amount / 100);

      return `เงินสด ${paymentAmount} บาท`;
    },
    totalCoinAmount() {
      if (this.package.totalCoinAmount) {
        const totalCoinAmount = formatCurrencyAndTwoDecimalsString(
          this.package.totalCoinAmount
        );

        return `ชำระด้วย MNCs / ${totalCoinAmount} บาท`;
      }
      return null;
    },
    couponCode() {
      if (this.package.couponCode) {
        return `ส่วนลด: ${this.package.couponCode} /`;
      }
      return null;
    },
    discountAmount() {
      if (this.couponCode) {
        let totalPrice = (this.totalPrice / 100) * this.quantity;

        if (this.package.discountAmount) {
          totalPrice = this.package.discountAmount / 100;
        } else if (this.package.totalCoinAmount) {
          totalPrice -= this.package.totalCoinAmount;
        }

        return `${formatCurrencyAndTwoDecimalsString(totalPrice)} บาท`;
      }
      return null;
    },
    purchasedAtText() {
      return toLocaleTH(this.purchasedAt).toFormat("dd MMMM yyyy HH:mm น.");
    },
    renewAtText() {
      if (this.status === subscriptionStatus.ONE_TIME) {
        return "-";
      }

      if (this.purchasedAt.hasSame(this.renewAt, "day")) {
        return "-";
      }

      return toLocaleTH(this.renewAt).toFormat("dd MMMM yyyy HH:mm น.");
    },
    statusText() {
      return this.status.toLowerCase();
    },
    statusClassList() {
      return [this.statusText];
    },
    currentAppointment() {
      let appointmentDate = 'รอนัดหมาย'
      if (this.appointmentDate) {
        appointmentDate = toLocaleTH(this.appointmentDate).toFormat("dd MMMM yyyy")

      } else if (this.status === 'CANCELLED') {
        appointmentDate = 'ยกเลิกแพ็กเกจ'
      }

      return appointmentDate
    },
    categoryText() {
      return this.category.toLowerCase();
    },
    categoryClassList() {
      return [this.categoryText];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.subscriber-row {
  display: grid;
  grid-template-columns: 120px repeat(4, 1fr) 200px 100px repeat(1, 1fr);
  grid-gap: 15px;
  align-items: center;

  padding: ($space / 2) $space;

  &:hover {
    background: #fafafa;
    cursor: pointer;
    text-decoration: none;
  }
}

.center {
  text-align: center;
}

.badge {
  display: inline-block;
  font-size: 0.9rem;
  padding: 4px 10px;
  border-radius: 4px;

  &.active {
    background-color: $success-color;
  }

  &.unsubscribed {
    background-color: $warning-color;
  }

  &.cancelled {
    background-color: $danger-color;
  }

  &.free_trial {
    background-color: $secondary-color;
  }

  &.one_time {
    background-color: $primary-color;
  }

  &.subscribe {
    background-color: $success-color;
  }
}

.subscriber-row > .cell {
  > h5 {
    color: black;
    font-size: 16px;
  }

  > p {
    font-size: 14px;
  }

  > h5,
  > p {
    line-height: 1.6;
    margin: 0;
  }
}

.original-price {
  text-decoration: line-through;
}

.font-red {
  color: rgb(250, 102, 102);
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/components/SubscriberRow.vue